import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { ADDRESSES_DOMAIN } from './constants';

const selectAddressesDomain = state => state[ADDRESSES_DOMAIN] || initialState;

export const selectAddressTypes = () =>
  createSelector(
    selectAddressesDomain,
    d => {
      let types = d.addressTypes.length ? d.addressTypes : JSON.parse(localStorage.getItem('address-types'));
      return types;
    },
  );

export const selectAddress = id =>
  createSelector(
    selectAddressesDomain,
    d => d.addresses[id],
  );
